import { track } from '@tldraw/tldraw'
import { FontWeightProps } from './Types'
import { useUpdateStyle } from '../VisualEditor/hooks/useUpdateStyle'
import { useState } from 'react'
import { ComboBox, ComboBoxProps } from 'components/ComboBox/ComboBox'
import { FontWeightStyle } from '../VisualEditor/StyleProps'
import { Item } from '@react-stately/collections'
import { FONT_WEIGHTS } from '../Shapes/TextBoxShape/constants'
import { observer } from 'mobx-react-lite'
import Styles from './FontWeight.module.scss'
import { useAvailableWeights } from '../VisualEditor/hooks/useAvailableWeights'

const FontWeight = track(
  observer(({ editor, style, fontFamilyStyle, italicStyle }: FontWeightProps) => {
    const [isSearching, setIsSearching] = useState(false)
    const updateStyle = useUpdateStyle(editor)
    const availableWeights = useAvailableWeights(fontFamilyStyle, italicStyle)

    const baseProps: Partial<ComboBoxProps> = {
      'aria-label': 'Font weight',
      size: 'md',
      wrapperClassName: Styles.comboboxWrapper,
      contentsClassName: Styles.comboboxContents,
      inputClassName: Styles.comboboxInput,
    }

    if (!isSearching) {
      return (
        <span>
          <ComboBox
            {...baseProps}
            onFocus={() => setIsSearching(true)}
            inputValue={style.type === 'shared' ? FONT_WEIGHTS[style.value] : 'Mixed'}
          >
            <Item>Mixed</Item>
          </ComboBox>
        </span>
      )
    }

    return (
      <ComboBox
        {...baseProps}
        autoFocus
        menuTrigger="focus"
        onBlur={() => setIsSearching(false)}
        onSelectionChange={(newWeight) => {
          if (!newWeight) return
          updateStyle(FontWeightStyle, parseInt(newWeight as string, 10))
          setIsSearching(false)
        }}
        selectedKey={style.type === 'shared' ? style.value : 'Mixed'}
        defaultInputValue=""
      >
        {availableWeights.map((weight) => {
          const textValue = FONT_WEIGHTS[weight]
          return (
            <Item key={weight} textValue={textValue}>
              <span style={{ fontWeight: weight }}>{textValue}</span>
            </Item>
          )
        })}
      </ComboBox>
    )
  }),
)

export { FontWeight }
